/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';
import ReactPlayer from 'react-player';

import iconSet from '../../../shared/images/teambuildr-selection.json';

const AnotherWrapper = styled('div')`
  position: relative;
  padding-top: 56.25%;
`;

const CloseButtonContainer = styled('div')`
  display: flex;
  justify-self: flex-end;
  align-items: center;
  cursor: pointer;
  margin-left: auto;
`;

const InnerWrapper = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
  .modal-button {
    align-items: center;
    background: '#ff6600';
  }
`;

const ModalWrapper = styled('div')`
  display: flex;
  width: 100%;
  .modal-button {
    align-items: center;
    background: '#ff6600';
  }
  .react-player {
    position: absolute;
    top: 0;
    left: 0;
    background-color: '#444444 !important';
  }
`;

const NavigationWrapper = styled('div')`
  display: flex;
  width: 100%;
  margin-bottom: -20px;
  z-index: 1;
  position: absolute;
  top: 0px;
  left: 0px;
  padding: 20px;
  margin-bottom: 30px;
`;

const MediaModalContent = ({ onRequestClose, mediaUrl }) => (
  <ModalWrapper>
    <NavigationWrapper>
      <CloseButtonContainer onClick={onRequestClose}>
        <IcomoonReact
          iconSet={iconSet}
          size={13}
          icon='remove'
          color='#ffffff'
        />
      </CloseButtonContainer>
    </NavigationWrapper>
    <InnerWrapper>
      <AnotherWrapper>
        <ReactPlayer
          className='react-player'
          url={mediaUrl}
          controls
          width='100%'
          height='100%'
          playing
        />
      </AnotherWrapper>
    </InnerWrapper>
  </ModalWrapper>
);

MediaModalContent.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  mediaUrl: PropTypes.string.isRequired,
};

export default MediaModalContent;
